export const TPL_UPLOAD = {
  action: 'tpl-upload',
  tooltip: 'Загрузить предзаполнение',
  icon: 'mdi-file-upload-outline',
}

export const TPL_DOWNLOAD = {
  action: 'tpl-download',
  tooltip: 'Получить шаблон',
  icon: 'mdi-file-download-outline',
}
